import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    subscriptionStartDate: z.iso.datetime(),
  }),
  response: z.void(),
};
